import { render, staticRenderFns } from "./PointBankTelecomApplicationComplete.vue?vue&type=template&id=3be60601"
import script from "./PointBankTelecomApplicationComplete.vue?vue&type=script&lang=js"
export * from "./PointBankTelecomApplicationComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports